export const PERMANENT_LINKS_DIALOG = 'PERMANENT_LINKS';
export interface PermanentLinksDialogProps {
  readonly stationGuid: string;
}

export const EDIT_DIRECTORY_DIALOG = 'EDIT_DIRECTORY';
export type EditDirectoryDialogProps =
  { mode: 'create'; parentGuid?: string } | { mode: 'edit'; directoryGuid: string };

export const EDIT_LINE_DIALOG = 'EDIT_LINE';
export type EditLineDialogProps = { mode: 'create'; parentGuid?: string } | { mode: 'edit'; lineGuid: string };

export const EDIT_STATION_DIALOG = 'EDIT_STATION';
export type EditStationDialogProps = { mode: 'create'; lineGuid?: string } | { mode: 'edit'; stationGuid: string };

export const STATION_INSERTION_DIALOG = 'STATION_INSERTION';
export type StationInsertionDialogProps = { stationGuid: string; defaultLineGuid?: string };

export const CREATE_TRAILER_DIALOG = 'CREATE_TRAILER';

export const CREATE_TRUCK_DRIVER_DIALOG = 'CREATE_TRUCK_DRIVER';

export const CREATE_ASSEMBLY_GROUPS_DIALOG = 'CREATE_ASSEMBLY_GROUPS';
export interface CreateAssemblyGroupsDialogProps {
  readonly initialLookupCode?: string;
}

export const SEND_ASSEMBLY_GROUP_DIALOG = 'SEND_ASSEMBLY_GROUP';
export interface SendAssemblyGroupDialogProps {
  readonly assemblyGroupGuid: string;
}

export const EDIT_ASSEMBLY_GROUP_PROPERTIES_DIALOG = 'EDIT_ASSEMBLY_GROUP_PROPERTIES_DIALOG';
export interface EditAssemblyGroupPropertiesDialogProps {
  readonly assemblyGroupGuid: string;
}
